import {ActionType} from '../actionTypes';
import {Action as PromotionsItemsActions, Action} from '../actions/promotionsItemsActions';

import {Dispatch} from 'redux';

import {SearchTermForUnlinkedPromotionsItems} from "../reducers/promotionsAndItemsReducer";
import {ErrorDtoFactory, FlyerPageDto, FlyerPageSpotDto, PromoDto, PromoItemsDto, UserDto} from "../../dtos";
import envManager from "../../com/envManager/EnvManager";
import axios from "axios";
import {Action as FlippingFlyerActions} from "../actions/flippingFlyerActions";
import {Action as FlyerDetailsActions} from "../actions/flyerDetailsActions";
import {FlyerDetailsState} from "../reducers/flyerDetailsReducer";


export const changeActiveUnlinkTab = (tabName: string) => {

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_ACTIVE_TAB_NAME,
            payload: tabName
        });
    }
}

export const changeSearchTermForUnlinkedPromotionsItems = (newState: SearchTermForUnlinkedPromotionsItems) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_SEARCH_TERM,
            payload: newState
        });
    }
}

export const savePromosItemsExcelFileInDBForLoadItemsImages = (file: any) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SAVE_PROMO_ITEMS_FILE_IN_STATE,
            payload: file
        });
    }
}

export const addPromosForUnlinkedPromotionsMenu = (newState: PromoDto[], isReplace?: boolean) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_PROMOS_TO_UNLINK_PROMOS,
            payload: {
                newState: newState,
                isReplace: isReplace
            }
        });
    }
}

export const addItemsForUnlinkedPromotionsItemsMenu = (newState: PromoItemsDto[], isReplace?: boolean) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_ITEMS_TO_UNLINK_ITEMS,
            payload: {
                newState: newState,
                isReplace: isReplace
            }
        });
    }
}

export const deletePromosFromUnlinkedPromotionsMenu = (newState: PromoDto[]) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.DELETE_PROMOS_FROM_UNLINK_PROMOS,
            payload: newState
        });
    }
}

export const deleteItemsFromUnlinkedPromotionsItemsMenu = (newState: PromoItemsDto[]) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.DELETE_ITEMS_FROM_UNLINK_ITEMS,
            payload: newState
        });
    }
}

export const clearDataForUnlinkedPromotionsItemsMenu = () => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU
        });
    }
}

export const toggleUnlinkPromotionsItemsPanel = (isOpen: boolean) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.TOGGLE_UNLINK_PANEL,
            payload: isOpen
        });
    }
}

export const changeQualifiedStatusForPromotionsAndItems = (isQualified: boolean) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_QUALIFIED_STATUS_FOR_PROMOTIONS_AND_ITEMS,
            payload: isQualified
        });
    }
}

export const changeSelectAllStatusForPromotionsAndItems = (isSelectAll: boolean) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_SELECT_ALL_STATUS_FOR_PROMOTIONS_AND_ITEMS,
            payload: isSelectAll
        });
    }
}
//unlink promo from frame and attach to flyer
export const attachPromoToFlyer = (flyerId: number, promos: number[], isDndEvent: boolean, lang: string = "en-US") => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ATTACH_PROMO_TO_FLYER_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyerId': flyerId,
                'uiLanguageCultureCode': lang,
                'promos': promos
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/AttachPromosToFlyer`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            if (isDndEvent) {
                dispatch({
                    type: ActionType.ATTACH_PROMO_TO_FLYER_DND_SUCCESS,
                    payload: data
                })
                dispatch({
                    type: ActionType.ATTACH_PROMO_TO_FLYER_DND_COMPLETE,
                    payload: data
                })

            } else {
                dispatch({
                    type: ActionType.ATTACH_PROMO_TO_FLYER_SUCCESS,
                    payload: data
                })
                dispatch({
                    type: ActionType.ATTACH_PROMO_TO_FLYER_COMPLETE,
                    payload: data
                })

            }


            // const flyersStatePayload: FlyersState = { ...flyersState,  flyers:[...newFlayerState] }
            // dispatch({ type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})

        } catch (err) {
            dispatch({
                type: ActionType.ATTACH_PROMO_TO_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

//unlink items from promo and attach to flyer
export const attachItemsToFlyer = (
    flyerId: number,
    promoItems: number[],
    isDndEvent: boolean,
    promo: PromoDto,
    targetFrameId?: number,
    lang: string = "en-US"
) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ATTACH_ITEMS_TO_FLYER_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyerId': flyerId,
                'uiLanguageCultureCode': lang,
                'promoItems': promoItems
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/AttachPromoItemsToFlyer`;
            let result = await axios.post(url, request, config);
            let data = result.data;


            // if (isDndEvent) {
            //     dispatch({
            //         type: ActionType.ATTACH_ITEMS_TO_FLYER_DND_SUCCESS,
            //         payload: {
            //             targetPromo: promo,
            //             itemsIds: promoItems,
            //             targetFrameId: targetFrameId,
            //         }
            //     })
            //     dispatch({
            //         type: ActionType.ATTACH_ITEMS_TO_FLYER_DND_COMPLETE,
            //         payload: data
            //     })
            //
            // } else {
            dispatch({
                type: ActionType.ATTACH_ITEMS_TO_FLYER_SUCCESS,
                payload: {
                    targetPromo: promo,
                    itemsIds: promoItems,
                    targetFrameId: targetFrameId,
                }
            })
            dispatch({
                type: ActionType.ATTACH_ITEMS_TO_FLYER_COMPLETE,
                payload: data
            })

            // }

        } catch (err) {
            dispatch({
                type: ActionType.ATTACH_ITEMS_TO_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}


//attach to frame unlinked promo
export const attachPromoToFrame = (promoId: number, frameId: number, isDnD: boolean, lang: string = "en-US", fromUnlinkMenu?: boolean) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ATTACH_PROMO_TO_FRAME_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'spotId': frameId,
                'uiLanguageCultureCode': lang,
                'promoId': promoId
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/AttachPromoToSpot`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            if (isDnD) {
                dispatch({
                    type: ActionType.ATTACH_PROMO_TO_FRAME_DND_SUCCESS,
                    payload: data
                })
                dispatch({
                    type: ActionType.ATTACH_PROMO_TO_FRAME_DND_COMPLETE,
                    payload: data
                })

            } else {
                dispatch({
                    type: ActionType.ATTACH_PROMO_TO_FRAME_SUCCESS,
                    payload: {
                        data: data,
                        fromUnlinkMenu: fromUnlinkMenu
                    }
                })
                dispatch({
                    type: ActionType.ATTACH_PROMO_TO_FRAME_COMPLETE,
                    payload: data
                })
            }

            // const flyersStatePayload: FlyersState = { ...flyersState,  flyers:[...newFlayerState] }
            // dispatch({ type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})
        } catch (err) {
            dispatch({
                type: ActionType.ATTACH_PROMO_TO_FRAME_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const attachItemsToPromo = (promoId: number, itemsId: number[], lang: string = "en-US") => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ATTACH_ITEM_TO_PROMO_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'promoItems': itemsId,
                'uiLanguageCultureCode': lang,
                'promoId': promoId
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/AttachPromoItemsToPromo`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            dispatch({
                type: ActionType.ATTACH_ITEM_TO_PROMO_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.ATTACH_ITEM_TO_PROMO_COMPLETE,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.ATTACH_ITEM_TO_PROMO_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const updateItem = (dataItem: any, lang: string) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.UPDATE_ITEM_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'promoItems': [dataItem],
                'uiLanguageCultureCode': lang,
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/UpdatePromoItems`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            dispatch({
                type: ActionType.UPDATE_ITEM_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.UPDATE_ITEM_COMPLETE,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.UPDATE_ITEM_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}


export const editPromotionItem = (
    itemData: any,
    languageCultureCode: string,
    imageSrcState: string,
    withPegPrice: boolean,
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.EDIT_PROMOTION_ITEM_START,
        });

        try {
            let result: any = await editPromotionItemRequest(
                itemData,
                languageCultureCode,
                imageSrcState,
                withPegPrice
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data;
            dispatch({
                type: ActionType.EDIT_PROMOTION_ITEM_SUCCESS,
                payload: flyer,
            });
            dispatch({type: ActionType.EDIT_PROMOTION_ITEM_COMPLETE});
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.EDIT_PROMOTION_ITEM_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),

            });
        }
    };
};


const editPromotionItemRequest = (
    itemData: any,
    contentLanguageCulture: string,
    imageSrcState: string,
    withPegPrice: boolean
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            const formData = new FormData();
            formData.append(`UserId`, userDto.userId.toString());
            // formData.append(`FlyerId`, itemData.flyerId);
            formData.append(`PromoItemId`, itemData.id);
            formData.append(`UiLanguageCultureCode`, contentLanguageCulture);
            // formData.append(`PromoId`, itemData.promoId);
            formData.append(`Code`, itemData.code.trim());
            formData.append(`Caption`, itemData.caption);
            formData.append(`DisplayCaption1`, itemData.displayCaption1);
            formData.append(`DisplayCaption2`, itemData.displayCaption2);
            if (withPegPrice) {
                formData.append(`RegularPrice`, itemData.regularPrice);
            }
            formData.append(`Keywords`, itemData.keywords);

            if (itemData.flyerId) {
                formData.append(`FlyerId`, itemData.flyerId);
            }
            if (itemData.promoId) {
                formData.append(`PromoId`, itemData.promoId);
            }

            if (imageSrcState === '') {
                formData.append(`Image`, 'null');
            } else if (itemData.file) {
                formData.append(`Image`, itemData.file, itemData.file.name);
            }

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/UpdatePromoItem`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};

export const createPromotionItem = (
    itemData: any,
    languageCultureCode: string,
    imageSrcState: string,
    withItemPrice: boolean,
) => {

    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.CREATE_PROMOTION_ITEM_START,
        });

        try {
            let result: any = await createPromotionItemRequest(
                itemData,
                languageCultureCode,
                imageSrcState,
                withItemPrice,
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data;
            dispatch({
                type: ActionType.CREATE_PROMOTION_ITEM_SUCCESS,
                payload: flyer,
            });
            dispatch({type: ActionType.CREATE_PROMOTION_ITEM_COMPLETE});
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.CREATE_PROMOTION_ITEM_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),

            });
        }
    };
};


const createPromotionItemRequest = (
    itemData: any,
    contentLanguageCulture: string,
    imageSrcState: string,
    withItemPrice: boolean,
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            const formData = new FormData();
            formData.append(`UserId`, userDto.userId.toString());
            // formData.append(`FlyerId`, itemData.flyerId);
            formData.append(`PromoItemId`, itemData.id);
            formData.append(`UiLanguageCultureCode`, contentLanguageCulture);
            formData.append(`Code`, itemData.code.trim());
            formData.append(`Caption`, itemData.caption);
            formData.append(`DisplayCaption1`, itemData.displayCaption1);
            formData.append(`DisplayCaption2`, itemData.displayCaption2);
            if (withItemPrice) {
                formData.append(`RegularPrice`, itemData.regularPrice);
            }
            formData.append(`Keywords`, itemData.keywords);
            if (itemData.flyerId) {
                formData.append(`FlyerId`, itemData.flyerId);
            }
            if (itemData.promoId) {
                formData.append(`PromoId`, itemData.promoId);
            }
            if (imageSrcState === '') {
                formData.append(`Image`, 'null');
            } else if (itemData.file) {
                formData.append(`Image`, itemData.file, itemData.file.name);
            }


            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/CreatePromoItem`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};


export const createItem = (dataItem: any, lang: string) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CREATE_ITEM_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'promoItems': [dataItem],
                'uiLanguageCultureCode': lang,
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/CreatePromoItems`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            dispatch({
                type: ActionType.CREATE_ITEM_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.CREATE_ITEM_COMPLETE,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.CREATE_ITEM_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const updatePromotion = (
    promoData: any,
    languageCultureCode: string,
    imageSrcState: string,
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);
    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.UPDATE_PROMOTION_START,
        });

        try {
            let result: any = await updatePromotionRequest(
                promoData,
                languageCultureCode,
                imageSrcState
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data;
            dispatch({
                type: ActionType.UPDATE_PROMOTION_SUCCESS,
                payload: flyer,
            });
            dispatch({type: ActionType.UPDATE_PROMOTION_COMPLETE});
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.UPDATE_PROMOTION_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),

            });
        }
    };
};

const updatePromotionRequest = (
    promoData: any,
    contentLanguageCulture: string,
    imageSrcState: string
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            const formData = new FormData();
            formData.append(`UserId`, userDto.userId.toString());
            // formData.append(`FlyerId`, itemData.flyerId);
            formData.append(`UiLanguageCultureCode`, contentLanguageCulture);
            formData.append(`PromoId`, promoData.promoId ? promoData.promoId : '');
            formData.append(`FlyerId`, promoData.flyerId ? promoData.flyerId : '');
            formData.append(`PageId`, promoData.pageId ? promoData.pageId : '');
            formData.append(`SpotId`, promoData.spotId ? promoData.spotId : '');
            formData.append(`ImageSelection`, promoData.imageSelection ? promoData.imageSelection : '');
            // formData.append(`PromoId`, itemData.promoId);
            formData.append(`Code`, promoData.code.trim());
            formData.append(`Caption`, promoData.caption);
            formData.append(`DisplayCaption1`, promoData.displayCaption1);
            formData.append(`SaleTypeCode`, promoData.saleTypeCode);
            formData.append(`Requisite`, promoData.requisite ? promoData.requisite : '');
            formData.append(`Benefit`, promoData.benefit ? promoData.benefit : '');
            formData.append(`Keywords`, promoData.keywords);
            formData.append(`ValidFromUtc`, promoData.validFromUtc);
            formData.append(`ValidToUtc`, promoData.validToUtc);
            formData.append(`SellingUnitId`, promoData.sellingUnitId);
            if (promoData.file) {
                formData.append(`Image`, promoData.file, promoData.file.name);
            } else {
                formData.append(`Image`, '');
            }

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/UpdatePromo`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};
export const createPromotion = (
    promoData: any,
    languageCultureCode: string,
    imageSrcState: string,
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);
    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.CREATE_PROMOTION_START,
        });

        try {
            let result: any = await createPromotionRequest(
                promoData,
                languageCultureCode,
                imageSrcState
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data;
            dispatch({
                type: ActionType.CREATE_PROMOTION_SUCCESS,
                payload: flyer,
            });
            dispatch({type: ActionType.CREATE_PROMOTION_COMPLETE});
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.CREATE_PROMOTION_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),

            });
        }
    };
};

const createPromotionRequest = (
    promoData: any,
    contentLanguageCulture: string,
    imageSrcState: string
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            const formData = new FormData();
            formData.append(`UserId`, userDto.userId.toString());
            // formData.append(`FlyerId`, itemData.flyerId);
            formData.append(`UiLanguageCultureCode`, contentLanguageCulture);
            formData.append(`PromoId`, promoData.promoId ? promoData.promoId : '');
            formData.append(`FlyerId`, promoData.flyerId ? promoData.flyerId : '');
            formData.append(`PageId`, promoData.pageId ? promoData.pageId : '');
            formData.append(`SpotId`, promoData.spotId ? promoData.spotId : '');
            formData.append(`ImageSelection`, promoData.imageSelection ? promoData.imageSelection : '');
            // formData.append(`PromoId`, itemData.promoId);
            formData.append(`Code`, promoData.code.trim());
            formData.append(`Caption`, promoData.caption);
            formData.append(`DisplayCaption1`, promoData.displayCaption1);
            formData.append(`SaleTypeCode`, promoData.saleTypeCode);
            formData.append(`Requisite`, promoData.requisite ? promoData.requisite : '');
            formData.append(`Benefit`, promoData.benefit ? promoData.benefit : '');
            formData.append(`Keywords`, promoData.keywords);
            formData.append(`ValidFromUtc`, promoData.validFromUtc);
            formData.append(`ValidToUtc`, promoData.validToUtc);
            formData.append(`SellingUnitId`, promoData.sellingUnitId);
            if (promoData.file) {
                formData.append(`Image`, promoData.file, promoData.file.name);
            } else {
                formData.append(`Image`, '');
            }

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/CreatePromo`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};


// export const updatePromotion = (promo: any, lang: string) => {
//     let userDtoStr = localStorage.getItem('userDto');
//     let userDto: UserDto = JSON.parse(userDtoStr!);
//
//     return async (dispatch: Dispatch<Action>) => {
//         dispatch({
//             type: ActionType.UPDATE_PROMOTION_START
//         })
//
//         try {
//             const config = {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': 'Bearer ' + userDto.token
//                 }
//             }
//
//             const request = {
//                 'userId': userDto.userId,
//                 'promos': [promo],
//                 'uiLanguageCultureCode': lang,
//             };
//             let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/UpdatePromos`;
//             let result = await axios.post(url, request, config);
//             let data = result.data;
//             dispatch({
//                 type: ActionType.UPDATE_PROMOTION_SUCCESS,
//                 payload: data
//             })
//             dispatch({
//                 type: ActionType.UPDATE_PROMOTION_COMPLETE,
//                 payload: data
//             })
//         } catch (err) {
//             dispatch({
//                 type: ActionType.UPDATE_PROMOTION_ERROR,
//                 payload: ErrorDtoFactory.createErrorDto(err)
//             })
//         }
//     }
// }

// export const createPromotion = (promo: any, lang: string) => {
//     let userDtoStr = localStorage.getItem('userDto');
//     let userDto: UserDto = JSON.parse(userDtoStr!);
//
//     return async (dispatch: Dispatch<Action>) => {
//         dispatch({
//             type: ActionType.CREATE_PROMOTION_START
//         })
//
//         try {
//             const config = {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': 'Bearer ' + userDto.token
//                 }
//             }
//
//             const request = {
//                 'userId': userDto.userId,
//                 'promos': [promo],
//                 'uiLanguageCultureCode': lang,
//             };
//             let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/CreatePromos`;
//             let result = await axios.post(url, request, config);
//             let data = result.data;
//             dispatch({
//                 type: ActionType.CREATE_PROMOTION_SUCCESS,
//                 payload: data
//             })
//             dispatch({
//                 type: ActionType.CREATE_PROMOTION_COMPLETE,
//                 payload: data
//             })
//         } catch (err) {
//             dispatch({
//                 type: ActionType.CREATE_PROMOTION_ERROR,
//                 payload: ErrorDtoFactory.createErrorDto(err)
//             })
//         }
//     }
// }


export const deletePromosFromFlyer = (promosIds: number[], isDeletePromoWithItems: boolean, flyerId: number, lang: string = "en-US") => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.DELETE_PROMO_FROM_FLYER_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyerId': flyerId,
                'uiLanguageCultureCode': lang,
                'promos': promosIds,
                'isDeletePromoItems': isDeletePromoWithItems
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/DeletePromos`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            if (isDeletePromoWithItems) {
                dispatch({
                    type: ActionType.DELETE_PROMO_WITH_ITEMS_FROM_FLYER_SUCCESS,
                    payload: data
                })
                dispatch({
                    type: ActionType.DELETE_PROMO_WITH_ITEMS_FROM_FLYER_COMPLETE,
                    payload: data
                })
            } else {
                dispatch({
                    type: ActionType.DELETE_PROMO_FROM_FLYER_SUCCESS,
                    payload: data
                })
                dispatch({
                    type: ActionType.DELETE_PROMO_FROM_FLYER_COMPLETE,
                    payload: data
                })
            }
            // const flyersStatePayload: FlyersState = { ...flyersState,  flyers:[...newFlayerState] }
            // dispatch({ type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_PROMO_FROM_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const deleteItemsFromFlyer = (promoItemsIds: number[], flyerId: number, lang: string = "en-US") => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.DELETE_ITEMS_FROM_FLYER_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyerId': flyerId,
                'uiLanguageCultureCode': lang,
                'promoItems': promoItemsIds,
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/DeletePromoItems`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            dispatch({
                type: ActionType.DELETE_ITEMS_FROM_FLYER_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.DELETE_ITEMS_FROM_FLYER_COMPLETE,
                payload: data
            })
            // const flyersStatePayload: FlyersState = { ...flyersState,  flyers:[...newFlayerState] }
            // dispatch({ type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_ITEMS_FROM_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const changeDraggingItemRecId = (recId: number | null) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_DRAGGING_ITEM_RECID,
            payload: recId
        });
    }
}

// export const changeStatusForShowOrHideAllItemsInAllPromotions = (isShow: boolean) => {
//     return async (dispatch: Dispatch<Action>) => {
//         dispatch({
//             type: ActionType.SHOW_HIDE_ALL_ITEMS_IN_ALL_PROMOTIONS,
//             payload: isShow
//         });
//     }
// }

export const setPagesForPromosAndItemsState = (pages: FlyerPageDto[]) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_PAGES_FOR_PROMOS_AND_ITEMS_STATE,
            payload: pages
        });
    }
}


export const setItemsToPromosItemsState = (items: PromoItemsDto[], pageNumber: number) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_ITEMS_TO_PROMO_ITEMS_STATE,
            payload: {
                pageIndex: pageNumber === 0 ? 1 : pageNumber,
                items: items
            }
        });
    }
}
export const addItemsToPromosItemsState = (items: PromoItemsDto[], pageNumber: number) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_ITEMS_TO_PROMO_ITEMS_STATE,
            payload: {
                pageIndex: pageNumber === 0 ? 1 : pageNumber,
                items: items
            }
        });
    }
}

export const removeItemsFromPromosAndAddToFlyerState = (items: PromoItemsDto[], pageNumber: number) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.REMOVE_ITEMS_TO_PROMO_ITEMS_STATE,
            payload: {
                pageIndex: pageNumber === 0 ? 1 : pageNumber,
                items: items
            }
        });
    }
}

export const setPromosToPromosItemsState = (promos: PromoDto[], pageNumber: number) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_PROMOS_TO_PROMO_ITEMS_STATE,
            payload: {
                pageIndex: pageNumber === 0 ? 1 : pageNumber,
                promos: promos
            }
        });
    }
}


export const uploadImageToItem = (
    flyRecId: number,
    image: File,
    languageCultureCode: string,
    itemId: number | null
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.POST_IMAGE_TO_ITEM_START,
        });

        try {
            let result: any = await postItemImage(
                flyRecId,
                image,
                itemId,
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data;
            dispatch({
                type: ActionType.POST_IMAGE_TO_ITEM_SUCCESS,
                payload: flyer,
            });
            dispatch({type: ActionType.POST_IMAGE_TO_ITEM_COMPLETED});
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.POST_IMAGE_TO_ITEM_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};
export const changeQualificationStatusForItems = (
    flyerPromoItemIds: number[],
    languageCultureCode: string,
    qualificationLevel: number,
    flyerState: FlyerDetailsState,
    onlyOne?: boolean,
    pageNumber?: number,
    isUnlinkedPromo?: boolean
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_START,
        });

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyerPromoItemIds': flyerPromoItemIds,
                'uiLanguageCultureCode': languageCultureCode,
                'qualificationLevel': qualificationLevel,
                'flyerId': flyerState.flyRecId
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/SetFlyerPromoItemsQualification`;
            let result = await axios.post(url, request, config);
            if (!onlyOne) {
                if (!isUnlinkedPromo) {
                    if (typeof pageNumber !== 'undefined') {
                        const newState = {...flyerState};
                        const totalApprovedPromos: PromoDto[] = [];
                        newState.flyerPages[pageNumber].flyerPageSpots?.forEach((frame: FlyerPageSpotDto, index) => {
                            const totalItemsApproved: PromoItemsDto[] = [];
                            const totalNotApproved: PromoItemsDto[] = [];
                            frame.flyerPromos?.forEach((promo: PromoDto) => {
                                promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                                    const currentItemExistInChangedQualificationItem = flyerPromoItemIds.some((changedItemId: number) => changedItemId === item.fpiRecId);
                                    if (currentItemExistInChangedQualificationItem) {
                                        item.qualificationLevel = qualificationLevel;
                                    }
                                    if (item.qualificationLevel === 2) {
                                        totalItemsApproved.push(item)
                                    }
                                    if (item.qualificationLevel === 0) {
                                        totalNotApproved.push(item)
                                    }
                                });
                                if (totalNotApproved.length > 0) {
                                    promo.qualificationLevel = 0;
                                } else if (promo.flyerPromoItems?.length !== totalItemsApproved.length) {
                                    promo.qualificationLevel = 1;
                                }

                                if (promo.qualificationLevel === 2) {
                                    totalApprovedPromos.push(promo);
                                }
                            });
                            frame.qualificationLevel = frame.fpsFrameType === 1 && frame.flyerPromos?.length ? frame.flyerPromos[0].qualificationLevel : frame.qualificationLevel;
                        })
                        if (totalApprovedPromos.length !== newState.flyerPages[pageNumber].flyerPageSpots?.length) {
                            newState.flyerPages[pageNumber].qualificationLevel = 1;
                        }

                        dispatch({
                            type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                            payload: newState,
                        });
                    }

                    dispatch({
                        type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_SUCCESS,
                        payload: flyerPromoItemIds
                    });


                    dispatch({
                        type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_COMPLETED,
                    })

                } else {
                    const newState = {...flyerState};
                    newState.flyerPromos?.forEach((promo: PromoDto) => {
                        const totalItemsApproved: PromoItemsDto[] = [];
                        const totalNotApproved: PromoItemsDto[] = [];
                        promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                            const currentItemExistInChangedQualificationItem = flyerPromoItemIds.some((changedItemId: number) => changedItemId === item.fpiRecId);
                            if (currentItemExistInChangedQualificationItem) {
                                item.qualificationLevel = qualificationLevel;
                            }
                            if (item.qualificationLevel === 2) {
                                totalItemsApproved.push(item)
                            }
                            if (item.qualificationLevel === 0) {
                                totalNotApproved.push(item)
                            }
                        });
                        if (totalNotApproved.length > 0) {
                            promo.qualificationLevel = 0;

                        } else if (promo.flyerPromoItems?.length !== totalItemsApproved.length) {
                            promo.qualificationLevel = 1;
                        }
                    })
                    dispatch({
                        type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                        payload: newState,
                    });

                    dispatch({
                        type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_SUCCESS,
                        payload: flyerPromoItemIds
                    });


                    dispatch({
                        type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_COMPLETED,
                    })

                }
            }
        } catch (err) {
            dispatch({
                type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    };
};

export const changeQualificationStatusForPromos = (
    flyerPromoIds: number[],
    languageCultureCode: string,
    qualificationLevel: number,
    flyerState: FlyerDetailsState,
    onlyOne?: boolean,
    pageNumber?: number
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<PromotionsItemsActions | FlyerDetailsActions>
    ) => {
        dispatch({
            type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_START,
        });

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'flyerPromoIds': flyerPromoIds,
                'uiLanguageCultureCode': languageCultureCode,
                'qualificationLevel': qualificationLevel,
                'flyerId': flyerState.flyRecId
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/SetFlyerPromosQualification`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            if (!onlyOne) {
                if (typeof pageNumber !== 'undefined') {
                    const newState = {...flyerState}
                    let totalApprovedPromos: PromoDto[] = [];
                    newState.flyerPages[pageNumber].flyerPageSpots?.forEach((frame: FlyerPageSpotDto) => {
                        frame.flyerPromos?.forEach((promo: PromoDto) => {
                            const currentItemExistInChangedQualificationItem = flyerPromoIds.some((changedItemId: number) => changedItemId === promo.flrRecId);
                            if (currentItemExistInChangedQualificationItem) {
                                promo.qualificationLevel = qualificationLevel;
                                if (qualificationLevel === 2) {
                                    promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                                        item.qualificationLevel = qualificationLevel;
                                    })
                                }
                            }
                            if (promo.qualificationLevel === 2) {
                                totalApprovedPromos.push(promo);
                            }
                        });
                        // frame.qualificationLevel = frame.fpsFrameType === 1 && frame.flyerPromos?.length ? frame.flyerPromos[0].qualificationLevel : frame.qualificationLevel;
                        frame.qualificationLevel = frame.fpsFrameType === 1 && frame.flyerPromos?.length && frame.flyerPromos[0].qualificationLevel === 1 ? frame.flyerPromos[0].qualificationLevel : frame.qualificationLevel;
                    })
                    if (totalApprovedPromos.length !== newState.flyerPages[pageNumber].flyerPageSpots?.length) {
                        newState.flyerPages[pageNumber].qualificationLevel = 1;
                    }


                    dispatch({
                        type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                        payload: newState,
                    });
                }

                dispatch({
                    type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_SUCCESS,
                    payload: data
                });


                dispatch({
                    type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_COMPLETED,
                    payload: data
                })
            } else {
                const newState = {...flyerState}
                newState.flyerPromos?.forEach((promo: PromoDto) => {
                    const currentItemExistInChangedQualificationItem = flyerPromoIds.some((changedItemId: number) => changedItemId === promo.flrRecId);
                    if (currentItemExistInChangedQualificationItem) {
                        promo.qualificationLevel = qualificationLevel;
                        if (qualificationLevel === 2) {
                            promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                                item.qualificationLevel = qualificationLevel;
                            })
                        }
                    }
                });

                dispatch({
                    type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                    payload: newState,
                });

                dispatch({
                    type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_SUCCESS,
                    payload: data
                });


                dispatch({
                    type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_COMPLETED,
                    payload: data
                })

            }
        } catch (err) {
            dispatch({
                type: ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    };
};

const postItemImage = (
    flyerId: number,
    file: File,
    itemId: number | null,
    // contentLanguageCulture: string,
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            const formData = new FormData();
            formData.append(`UserId`, userDto.userId.toString());
            formData.append(`FlyerId`, flyerId.toString());
            formData.append(`PromoItemId`, itemId ? itemId.toString() : '');
            formData.append(`Image`, file, file.name);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/UpdatePromoItemImage`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};


export const deleteImageFromItems = (items: number[], lang: string = "en-US") => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.DELETE_IMAGE_FROM_ITEM_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'items': items,
                'uiLanguageCultureCode': lang,
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/DeletePromoItemsImage`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            dispatch({
                type: ActionType.DELETE_IMAGE_FROM_ITEM_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.DELETE_IMAGE_FROM_ITEM_COMPLETE,
                payload: data
            })
            // const flyersStatePayload: FlyersState = { ...flyersState,  flyers:[...newFlayerState] }
            // dispatch({ type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_IMAGE_FROM_ITEM_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const deleteImageFromPromotion = (promo: number, lang: string = "en-US") => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.DELETE_IMAGE_FROM_PROMOTION_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'promoId': promo,
                'uiLanguageCultureCode': lang,
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/DeletePromoImage`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            dispatch({
                type: ActionType.DELETE_IMAGE_FROM_PROMOTION_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.DELETE_IMAGE_FROM_PROMOTION_COMPLETE,
            })
            // const flyersStatePayload: FlyersState = { ...flyersState,  flyers:[...newFlayerState] }
            // dispatch({ type: ActionType.CHANGE_FLYERS_STATE, payload: flyersStatePayload})
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_IMAGE_FROM_PROMOTION_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

